document.addEventListener("DOMContentLoaded", function () {
  // Create the script element for Google Tag Manager
  var gtagScript = document.createElement("script");
  gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-NZDY293L5J";
  gtagScript.async = true;
  document.head.appendChild(gtagScript); // Append to the document's head

  // Add the gtag configuration script
  gtagScript.onload = function () {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-NZDY293L5J");
  };
});
